import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=e88de3b8&rel=stylesheet%2Fscss&lang=scss&scoped=true"
import "./index.vue?vue&type=style&index=1&id=e88de3b8&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e88de3b8"]])

export default __exports__